
import * as React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import styled from 'styled-components';

import { ExpandIcon } from '@process-advisor/process-miner/navigation/sidebar/expansionPanel/expandIcon';
import { getColor } from '@process-advisor/process-miner/shared/theme';

const StyledAccordion = styled(Accordion)`
    box-shadow: none !important;
    border: 0 !important;
    border-bottom: 1px solid #EBECF0 !important;
    border-radius: 0 !important;
    font-size: 14px;
    margin: 0 !important;
    background: #FFFFFF;

    &.Mui-expanded {
        margin: 0 !important;
    }

    &:before {
        display: none;
    }

    &.Mui-focused,
    &:focus,
    &:focus-within {
        outline: none !important;
    }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
    min-height: 42px !important;
    font-size: 14px;
    padding: 0 10px !important;
    color: #172B4D;
    background: #FFFFFF;

    &.Mui-expanded {
        min-height: 42px !important;
        background: #FFFFFF;
        border-bottom: 1px solid #EBECF0;
    }

    &.Mui-focusVisible,
    &:focus,
    &:focus-visible {
        background: #F7F8F9 !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .MuiAccordionSummary-content {
        margin: 0 !important;
        align-items: center;
    }

    .MuiAccordionSummary-content.Mui-expanded {
        margin: 0 !important;
    }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
    padding: 0 0 12px;
    background: #FFFFFF;
`;

type Props = {
    title: string;
    expanded?: boolean
    disabled?: boolean
}

export const ExpansionPanel: React.FC<Props> = React.memo(({
    title,
    children,
    expanded = false,
    disabled = false,
}) => {
    const [stateExpanded, setStateExpanded] = React.useState(expanded);
    const [stateDisabled, setStateVisible] = React.useState(disabled);

    React.useEffect(() => {
        setStateExpanded(expanded);
    }, [expanded]);

    return (
        <StyledAccordion
            onChange={() => setStateExpanded(!stateExpanded)}
            disableGutters={true}
            disabled={stateDisabled}
            expanded={stateExpanded}>
            <StyledAccordionSummary
                expandIcon={<ExpandIcon />}>
                {title}
            </StyledAccordionSummary>
            <StyledAccordionDetails>
                {children}
            </StyledAccordionDetails>
        </StyledAccordion>
    );
});

/*
            <AccordionDetails sx={{ display: 'flex', maxHeight: "50vh", overflowY: "scroll", pt: 0, pr: 0, pb: 16}}>
                {children}
            </AccordionDetails>
*/